'use client'

import { MY_PURCHASES } from 'links/constants/links'
import { ClientLink } from 'utils/link/client'

import type {
	SinglePurchaseClientLinkInnerProps,
	SinglePurchaseLinkProps,
} from '../types/types'

export function SinglePurchaseClientLink({
	purchaseId,
	children,
	linkProps,
	className,
}: SinglePurchaseLinkProps): React.ReactNode {
	const href = `${MY_PURCHASES}/detail?type=online&purchaseId=${purchaseId}`

	const props: SinglePurchaseClientLinkInnerProps = {
		...linkProps,
		href,
		children,
		className,
	}

	return <ClientLink {...props} />
}
